/** Gerado por scripts/generate-build-meta.mjs — não editar manualmente */
export const APP_BUILD_META = {"buildId":"nogit-20260915T133221","builtAt":"2026-09-15T13:32:21.468Z","gitSha":"nogit"} as const;
